export default __webpack_public_path__ + "img/logo-full.e849dab8.png";